import Container from './Container';

export default { Container };
